import React, { SyntheticEvent, useEffect, useMemo, useState } from "react";
import { CheckboxProps, Dropdown, DropdownProps } from "semantic-ui-react";

import { RowInfo } from "react-table-6";

// UX
import CardSupplyOrderQueueListUX from "./CardSupplyOrderQueueListUX";
import CardPatientSearchBox from "react-lib/apps/HISV3/TPD/CardPatientSearchBox";

// Common
import DropdownOptions from "react-lib/appcon/common/DropdownOptions";
import PaginationShorthand from "react-lib/appcon/common/PaginationShorthand";
import ButtonListSelection from "react-lib/appcon/common/ButtonListSelection";

// Utils
import { formatUTCtoBEString } from "react-lib/utils/dateUtils";
import { useIntl } from "react-intl";
import { SUPPLY_ORDER_LIMIT } from "../sequence/DispensingOrderSupply";
import ModInfo from "react-lib/apps/common/ModInfo";

// todo --- ดึงมาจาก api ถ้ามี
const SUPPLY_TYPE_OPTIONS = [
  { key: 1, value: "HOME", text: "HOME" },
  { key: 2, value: "REFILL", text: "REFILL" },
  { key: 3, value: "ONE DAY", text: "ONE DAY" },
  { key: 4, value: "STAT", text: "STAT" },
  { key: 5, value: "COST_CENTER", text: "Cost center" },
];

const CARD_SUPPLY_ORDER_QUEUE_LIST = "CardSupplyOrderQueueList";

const CardSupplyOrderQueueList = (props: any) => {
  const intl = useIntl();
  const [barcodeScan, setBarcodeScan] = useState<string>("");

  // Effect
  useEffect(() => {
    props.runSequence({ sequence: "DispensingOrderSupply", restart: true });
  }, []);

  // Memo
  const orderQueueItems = useMemo(
    () =>
      // orderQueue.map((item: any) => ({
      (props.DispensingOrderSupplySequence?.orderQueue || []).map((item: any) => ({
        ...item,
        type: item.type === "COST_CENTER" ? "Cost center" : item.type,
        clinic:
          props.masterOptions?.division?.find((option: any) => option.value === item.order_div)
            ?.text || "",
        requested: item.requested ? formatUTCtoBEString(item.requested).join(" ") : "",
        printed: item.printed ? formatUTCtoBEString(item.printed).join(" ") : "",
        checked: item.checked ? formatUTCtoBEString(item.checked).join(" ") : "",
        delivered: item.delivered ? formatUTCtoBEString(item.delivered).join(" ") : "",
      })),
    [props.DispensingOrderSupplySequence?.orderQueue, /*orderQueue*/ props.masterOptions]
  );

  // PRINTED
  const supplyOrderStatus = useMemo(() => {
    return props.supplyOrderStatus?.filter((item) => item.value !== "PRINTED")
  }, [props.supplyOrderStatus])

  // Handler
  const handleChangeDivision = (e: SyntheticEvent, data: DropdownProps) => {
    props.setProp("DispensingOrderSupplySequence.filterDivision", data.value);
  };

  const handleChangeState = (e: SyntheticEvent, data: DropdownProps) => {
    props.setProp("DispensingOrderSupplySequence.filterStatus", data.value);
  };

  const handleChangePatient = (id: any, hn: any) => {
    const newHn = id ? hn : "";

    props.setProp("DispensingOrderSupplySequence.hn", newHn);

    //* issue 70649
    props.runSequence({
      sequence: "DispensingOrderSupply",
      action: "search",
      activePage: 1,
      hn: newHn,
    });
  };

  const handleChangeValue = (e: any, v: any) => {
    props.setProp(`DispensingOrderSupplySequence.${v.name}`, v.hn);
  };

  const handleChangeType = (e: any, data: { value: (number | string)[] }) => {
    props.setProp(`DispensingOrderSupplySequence.filterType`, data.value);
  };

  const handleChangeIPD = (e: SyntheticEvent, data: CheckboxProps) => {
    props.setProp("DispensingOrderSupplySequence.isIPD", data?.checked);
  };

  const handleChangeOPD = (e: SyntheticEvent, data: CheckboxProps) => {
    props.setProp("DispensingOrderSupplySequence.isOPD", data?.checked);
  };

  const handleFilter = () => {
    props.runSequence({
      sequence: "DispensingOrderSupply",
      action: "search",
      activePage: 1,
    });
  };

  const handleChangePage = (activePage: number) => {
    props.runSequence({
      sequence: "DispensingOrderSupply",
      action: "search",
      activePage,
    });
  };

  const handleSelect = (rowInfo: RowInfo) => {
    const { encounter, id } = rowInfo?.original;

    if (encounter) {
      props.runSequence({
        sequence: "DispensingOrderSupply",
        action: "select",
        encounter: encounter,
        orderId: id,
      });

      props?.forward();
    }
  };

  const handleGetTrProps = (state: any, rowInfo: any, column: any, instance: any) => {
    return {
      style: {
        color: rowInfo?.original?.type === "STAT" ? "#db2828" : "",
        fontWeight: rowInfo?.original?.type === "STAT" ? "bold" : "",
      },
      onDoubleClick: (e: any) => {
        handleSelect(rowInfo);
      },
      onClick: (e: any) => {
        handleSelect(rowInfo);
      },
    };
  };

  const handleKeyDownBarcode = (e: KeyboardEvent) => {
    if (e.key === "Enter" && barcodeScan) {
      props.runSequence({
        sequence: "DispensingOrderSupply",
        action: "getSupplyOrderByBarcode",
        barcode: barcodeScan,
        btnAction: `${CARD_SUPPLY_ORDER_QUEUE_LIST}_barcode`,
        onSuccess: (data: any) => {
          setBarcodeScan("");

          if (data.encounter) {
            props.runSequence({
              sequence: "DispensingOrderSupply",
              action: "select",
              encounter: data.encounter,
              orderId: data.id,
            });

            props?.forward();
          }
        },
      });
    }
  };

  const handleCloseModBarcode = () => {
    props.setProp(`errorMessage.${CARD_SUPPLY_ORDER_QUEUE_LIST}_barcode`, null);
  };

  return (
    <div id="CardSupplyOrderQueueList" style={{ flex: "auto 1 1" }}>
      <CardSupplyOrderQueueListUX
        cardPatientSearchBox={
          <div style={{ margin: "0px 10px" }}>
            <CardPatientSearchBox
              // controller
              controller={props.drugOrderQueueController}
              // data
              // defaultValue={props.DispensingOrderSupplySequence?.hn}
              clearHNInput={!props.DispensingOrderSupplySequence?.hn ? true : false}
              // callback
              onEnterPatientSearch={handleChangePatient}
              languageUX={props.languageUX}
            />
          </div>
        }
        divisionSearchBox={
          <Dropdown
            search={true}
            selection={true}
            clearable={true}
            fluid={true}
            options={props.masterOptions?.division || []}
            onChange={handleChangeDivision}
            value={props.DispensingOrderSupplySequence?.filterDivision}
            style={{ margin: "0px 10px" }}
          />
        }
        orderSearchBox={
          <DropdownOptions
            value={props.DispensingOrderSupplySequence?.filterStatus || ""}
            multiple={true}
            search={true}
            placeholder={intl.formatMessage({ id: "เลือก Order Status" })}
            checked={true}
            inline={true}
            searchBox={true}
            options={supplyOrderStatus || []}
            onChange={handleChangeState}
          />
        }
        supplyOrderQueueList={orderQueueItems}
        runSequence={props.runSequence}
        onFilter={handleFilter}
        btnLoading={props.DispensingOrderSupplySequence?.loading}
        // filter
        isIPD={props.DispensingOrderSupplySequence?.isIPD}
        isOPD={props.DispensingOrderSupplySequence?.isOPD}
        onChangeIPD={handleChangeIPD}
        onChangeOPD={handleChangeOPD}
        typeSearchBox={
          <ButtonListSelection
            options={SUPPLY_TYPE_OPTIONS}
            value={props.DispensingOrderSupplySequence?.filterType}
            onChange={handleChangeType}
            name="filterType"
          />
        }
        getTrProps={handleGetTrProps}
        Pagination={
          <PaginationShorthand
            activePage={props.DispensingOrderSupplySequence?.activePage || 1}
            limit={SUPPLY_ORDER_LIMIT}
            total={props.DispensingOrderSupplySequence?.orderQueueTotal}
            onPageChange={handleChangePage}
          />
        }
        barcodeLoading={!!props.buttonLoadCheck?.[`${CARD_SUPPLY_ORDER_QUEUE_LIST}_barcode`]}
        onChangeBarcode={(e: any, data: any) => {
          setBarcodeScan(data.value);
        }}
        onKeyDownBarcode={handleKeyDownBarcode}
        barcodeScan={barcodeScan}
        languageUX={props.languageUX}
      />

      <ModInfo
        open={props.errorMessage?.[`${CARD_SUPPLY_ORDER_QUEUE_LIST}_barcode`]}
        type="error"
        onClose={handleCloseModBarcode}
        onApprove={handleCloseModBarcode}
      >
        <div style={{ fontWeight: "bold", lineHeight: 2, margin: "1rem 0 0.75rem" }}>
          <div>ไม่พบรายการใบสั่งจ่ายเวชภัณฑ์</div>
          <div>
            Order No. “
            {props.errorMessage?.[`${CARD_SUPPLY_ORDER_QUEUE_LIST}_barcode`]?.barcode || ""}”
          </div>
        </div>
      </ModInfo>
    </div>
  );
};

export default React.memo(CardSupplyOrderQueueList);
